import 'babel-polyfill';

import * as Sentry from '@sentry/vue';
import Vue from 'vue';
import router from '@/router';
import store from '@/store';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@/plugins/vuetify';
import '@/plugins/chartist';
import '@/plugins/amplify';
import '@/plugins/tinymce';
import '@/plugins/cssPolyfill';

import '@/filters/emailStatus';
import '@/filters/eventGuestState';
import '@/filters/stringToDate';
import '@/filters/gender';
import '@/filters/salutation';
import '@/filters/formal';

import App from '@/App.vue';

Vue.config.productionTip = false;

Sentry.init({
              Vue,
              dsn: 'https://625c144a3df30e3847731885dddef3ef@o1144584.ingest.sentry.io/4506258628804608',
              integrations: [
                new Sentry.BrowserTracing({
                                            tracePropagationTargets: ['localhost'],
                                            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                                          }),
                new Sentry.Replay(),
              ],
              tracesSampleRate: 1.0,
              replaysSessionSampleRate: 0.1,
              replaysOnErrorSampleRate: 1.0,
            });

new Vue({
          router,
          store,
          render: (h) => h(App),
        }).$mount('#app');
